import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=5e872268&scoped=true"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e872268",
  null
  
)

export default component.exports